import Button from '@eduzz/houston-ui/Button';
import {
  Avatar,
  Card,
  CardContent,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
  Badge,
  Chip,
} from '@material-ui/core';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { IAccess } from 'v2/interfaces/account';

import useStyles from './styles';

function AccountItemWrapper({ access, children }: { access: IAccess; children: React.ReactNode }) {
  const classes = useStyles();

  if (access.isMe) {
    return (
      <Badge
        className={classes.accountItemMainBadge}
        classes={{
          anchorOriginTopRightRectangle: classes.accountItemMainBadgePosition,
        }}
        badgeContent={<Chip label='Principal' color='primary' size='small' />}
      >
        {children}
      </Badge>
    );
  }

  return <>{children}</>;
}

const SelectAccount = () => {
  const classes = useStyles();
  const [accesses] = useObservable(() => eduzzAccountsService.getAccesses(), []);

  const onChange = useCallback((access: IAccess) => {
    eduzzAccountsService.changeAccount(access.email);
  }, []);

  if (!accesses || (accesses && !accesses.length)) return null;

  return (
    <div className={classes.page}>
      <div className={classes.content}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant='subtitle1'>
              <strong>Entrar como:</strong>
            </Typography>
          </CardContent>

          <List>
            {accesses.map((access, index) => (
              <Tooltip
                arrow={true}
                disableFocusListener={access.termsAcceptance || access.isMe}
                disableHoverListener={access.termsAcceptance || access.isMe}
                disableTouchListener={access.termsAcceptance || access.isMe}
                title={
                  <Typography variant='body2'>
                    O titular desta conta ainda não aceitou a atualização dos nossos Termos de Uso. Solicite a confirmação para o responsável e assim
                    que ele a fizer o seu acesso será liberado. Em caso de dúvidas entre em contato com o nosso suporte: suporte@eduzz.com
                  </Typography>
                }
                placement='left'
                key={access.id}
              >
                <div>
                  <AccountItemWrapper access={access}>
                    <ListItem
                      id={`access-control-${index}`}
                      onClick={() => onChange(access)}
                      disabled={!access.termsAcceptance && !access.isMe}
                      classes={{
                        container: classes.accountItem,
                      }}
                      button
                    >
                      <ListItemAvatar>
                        <Avatar src={access.photo}>{access.name?.substr(0, 1)}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={access.name} secondary={access.email} />
                      <ListItemSecondaryAction>
                        <IconButton disabled={!access.termsAcceptance && !access.isMe}>
                          <Icon>chevron_right</Icon>
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </AccountItemWrapper>
                </div>
              </Tooltip>
            ))}
          </List>
          <Button variant='text' fullWidth onClick={() => eduzzAccountsService.logout()}>
            Sair
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default SelectAccount;
